import React from "react";
import Primitives from "../../../components/primitives";
import Loading from "../../../components/loading";
import { colors } from "../../../components/utils/theme";
import { array, bool, func, oneOfType, string } from "prop-types";
const propTypes = {
  children: oneOfType([array, string]),
  isLoaded: bool,
  handleSubmit: func
};
const Button = ({ children, isLoaded, handleSubmit }) => (
  <Primitives.Button
    active={{ backgroundColor: colors.primary[6], color: "white" }}
    background={colors.primary[3]}
    borderRadius={4}
    color={colors.white}
    disabled={isLoaded}
    fontFamily="lato"
    fontSize={2}
    fontWeight={3}
    hover={{ backgroundColor: colors.primary[6], color: "white" }}
    onClick={handleSubmit}
    py={10}
  >
    {isLoaded ? (
      <Primitives.Flex justifyContent="center" height={18}>
        <Loading onlySpinner={true} />
      </Primitives.Flex>
    ) : (
      children
    )}
  </Primitives.Button>
);
Button.propTypes = propTypes;
export default Button;
